import getMeta from '@atlassian/jira-get-meta';

export const isSyntheticTenant = () => getMeta('ajs-is-synthetic') === 'true';
